const BaseComponent = require('base/base-component');

class List extends BaseComponent {
  init (){
    // this.appendNewTag();
  }
  appendNewTag () {
    const $pubTime = this.$el.find('.home-purchase-news');
    $pubTime.each((_, el) => {
      let timeString = $(el).data('value') + '';
      if (timeString) {
        timeString = timeString.replace('CST', 'GMT+0800');
      }
      // 当天发的公告打new标记
      if (new Date().toDateString() === new Date(timeString).toDateString()) {
        // $(el).before($('<i class="iconfont icon-newchunse"></i>'));
        $(el).parent().has('.icon-newchunse')[0] ? 0 : $(el).before($('<i class="iconfont icon-newchunse"></i>'));
      }
    });
  }
}
module.exports = List;
